import gql from 'graphql-tag';
import * as React from 'react';
import { compose, graphql, MutationFunc } from 'react-apollo';

import Form from '../components/FormGenerator/Form';
import { passwordFields } from '../formFields';
import { Button, Section, Title } from '../modules/modules';
import FlashStore from '../services/FlashStore';
import UserWrap from '../components/UserWrap';

interface IUserPasswordState {
  formFields: any[];
  formValues: any;
  errorMessage: string;
}

interface IUserPasswordProps {
  changePassword?: MutationFunc;
}

class UserPassword extends React.Component<IUserPasswordProps, IUserPasswordState> {

  constructor(props: IUserPasswordProps) {
    super(props);

    this.state = {
      formFields: passwordFields,
      formValues: {},
      errorMessage: ''
    };

    this.handleChange = this.handleChange.bind(this);
  }

  public handleChange(value: any, field: string) {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public setFormState(fields: any) {
    this.setState({ 
      formFields: fields 
    });
  }

  public async handleSend(form: any) {
    const valid = await form.validate((fields: any) => {
      this.setFormState(fields);
    });

    if (valid) {
      if (this.props.changePassword) {
        try {
          await this.props.changePassword({
            variables: {
              oldPassword: this.state.formValues.OldPassword,
              newPassword: this.state.formValues.Password
            }
          });

          this.setState({
            errorMessage: '',
            formValues: {},
          });

          FlashStore.GetInstance().showMessage('Password has been changed', 'success');
        } catch (e) {
          this.setState({ errorMessage: e.message.replace('GraphQL error: ', '') });
        }
      }
    }
  }

  public render() {
    return (
      <main>
        <Section type="userPage">
          <UserWrap>

            <div className="form form--password">
              <Title type="lower">Change password</Title>
              <Form
                fields={this.state.formFields}
                values={this.state.formValues}
                handleChange={this.handleChange}
              >
                {(form: any) => {
                  return (
                    <div>
                      {this.state.errorMessage !== '' && (
                        <div className="form__message">{this.state.errorMessage}</div>
                      )}
                      <Button
                        type="red"
                        onClick={() => {
                          this.handleSend(form);
                        }}
                      >
                        Save password
                      </Button>
                    </div>
                  );
                }}
              </Form>
            </div>

          </UserWrap>
        </Section>
      </main>
    );
  }
}

const changePwdMutation = gql`
  mutation changePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`;

export default compose(
  graphql<any, any>(changePwdMutation, {
    name: 'changePassword'
  })
)(UserPassword);



// WEBPACK FOOTER //
// ./src/pages/UserPassword.tsx